export default __webpack_public_path__ + "static/Blog (1)-2089fe621711690b78dc44f55fd6738d.jpg";